<script setup lang="ts">
import { ref } from 'vue';
import { getEnvironmentFromHostname } from '@/utils';

const visible = ref(false);
const env = getEnvironmentFromHostname();
const SUPPORT_QR_URLS = {
  local:
    'https://cdn-fx.nio.com/fx/nio-mate-web/__cdn__/support_qrcode/tech_support.png',
  dev: 'https://cdn-fx.nio.com/fx/nio-mate-web/__cdn__/support_qrcode/tech_support.png',
  test: 'https://cdn-fx.nio.com/fx/nio-mate-web/__cdn__/support_qrcode/tech_support.png',
  stg: 'https://cdn-fx.nio.com/fx/nio-mate-web/__cdn__/support_qrcode/tech_support.png',
  prod: 'https://cdn-fx.nio.com/fx/nio-mate-web/__cdn__/support_qrcode/operation_support.png',
};

const openDialog = () => {
  visible.value = true;
};

const closeDialog = () => {
  visible.value = false;
};

defineExpose({ openDialog, closeDialog });
</script>

<template>
  <n-dialog
    size="small"
    v-model="visible"
    title="飞书扫码入群"
    :secondary-button="false"
    :primary-button="false"
  >
    <div class="wrapper">
      <img :src="SUPPORT_QR_URLS[env]" alt="飞书扫码入群" />
    </div>
  </n-dialog>
</template>

<style scoped lang="scss">
.wrapper {
  img {
    width: 100%;
    display: block;
  }
}
</style>
